<div>
    <p class="review-text">abgegebene Bewertungen: {{getAllReviewsValue()}}</p>
    <div class="review-chart-container">
        <div class="review-stars-container">
            <div class="star-block" *ngFor="let rating of getRatings()">
                <span *ngFor="let star of getStars()" class="custom-star fa"
                    [class]="star <= rating ? 'fa-star' : 'fa-star-o'">
                </span>
            </div>
        </div>
        <ngx-charts-bar-horizontal class="custom-chart-style" #review [view]="view" [barPadding]="4"
            [scheme]="colorScheme" [results]="data" [gradient]="false" [roundEdges]="false" [showDataLabel]="true"
            [tooltipDisabled]="false" (select)="onSelect($event)" (activate)="onActivate($event)"
            (deactivate)="onDeactivate($event)">
            <ng-template #tooltipTemplate let-model="model">
                <div class="custom-tooltip">
                    {{getPercentage(model.value)}} %
                </div>
            </ng-template>
        </ngx-charts-bar-horizontal>
    </div>
</div>